import { Image, Flex, Spacer } from "@chakra-ui/react";
import React, { memo, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDocumentTitle, useImageIntersectionObserver, useLocalStorage, useShowBackToTopBtn } from "@/hooks";
import SwiperComponent from "./swiper";
import WhyComponent from "./whynew";
import WhatComponent from "./what";
import HowComponent from "./how";
import ProjectSupportedComponent from "./support";
import BottomComponent from "./bottom";
import PricingComponent from "./pricing";
import HomeHeaderComponent from "./header";
function HomeComponent() {
   const location = useLocation();
   const pricingRef = useRef();
   const exampleRef = useRef();
   const [topShow] = useShowBackToTopBtn();
   const [locationKey, setLocationKey] = useLocalStorage("location-key");
   useDocumentTitle("AlohaBots | 1st Choice for NFT Sales Bot");
   useImageIntersectionObserver();
   useEffect(() => {
      if (locationKey !== location.key && location.state != null && location.state.jump) {
         setTimeout(() => {
            if (location.state.type === "example") {
               exampleRef.current.scrollIntoView({ behavior: "smooth" });
            } else if (location.state.type === "price") {
               pricingRef.current.scrollIntoView({ behavior: "smooth" });
            }
         }, 10);
         setLocationKey(location.key);
      }
   }, [location, locationKey, setLocationKey]);
   return (
      <Flex pos={"relative"} flexDir={"column"} mt={{ base: "50px", BREAK_PAD: "90px", BREAK_LPC: "130px" }}>
         <HomeHeaderComponent />
         <SwiperComponent />
         <WhyComponent />
         <HowComponent />
         <WhatComponent />
         <Spacer ref={exampleRef} />
         <ProjectSupportedComponent />
         <Spacer ref={pricingRef} />
         <PricingComponent />
         <BottomComponent />
         <Image
            alt="backToTop"
            zIndex={100}
            boxSize={{ base: "38px", BREAK_PAD: "42px" }}
            display={topShow ? "block" : "none"}
            cursor={"pointer"}
            pos={"fixed"}
            userSelect={"none"}
            bottom={{ base: "70px", BREAK_PAD: "70px" }}
            right={{ base: "20px", BREAK_PAD: "33px" }}
            src={process.env.REACT_APP_PUBLIC_URL + "iconfont/back_to_top.svg"}
            onClick={() => {
               window.scrollTo({ top: 0, behavior: "smooth" });
            }}
         />
      </Flex>
   );
}
export default memo(HomeComponent);
